import React, { useState } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Fleet from '@/components/Fleet';
import Features from '@/components/Features';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import BookingForm from '@/components/BookingForm';
import { Toaster } from '@/components/ui/toaster';

const Home = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar onBookNowClick={() => setIsBookingOpen(true)} />
      <Hero onBookNowClick={() => setIsBookingOpen(true)} />
      <Services />
      <Fleet />
      <Features />
      <Testimonials />
      <Contact />
      <Footer />
      <BookingForm isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
